import { useState } from 'react';
import { useAuth } from '../lib/auth';

export function Login() {
  const { signInWithMagicLink } = useAuth();
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'sending' | 'sent' | 'error'>('idle');
  const [message, setMessage] = useState<string>('');

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setStatus('sending');
    setMessage('');
    const { error } = await signInWithMagicLink(email);
    if (error) {
      setStatus('error');
      setMessage(error);
    } else {
      setStatus('sent');
      setMessage(`Magic link sent to ${email}. Check your inbox.`);
    }
  };

  return (
    <div className="h-full grid place-items-center p-8">
      <div className="panel shadow-hud p-8 w-full max-w-md space-y-5">
        <div className="space-y-1">
          <div className="font-mono text-xs tracking-widest text-amberHi">◆ TASK&nbsp;BOARD</div>
          <h1 className="text-xl font-semibold">Operator sign-in</h1>
          <p className="text-sm text-muted">Magic link. Only allowlisted emails can sign in.</p>
        </div>

        <form onSubmit={submit} className="space-y-3">
          <input
            type="email"
            required
            placeholder="you@shwetzer.com"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="w-full px-3 py-2 bg-panelHi border border-border rounded-md
                       text-ink placeholder-dim font-mono text-sm
                       focus:outline-none focus:border-amber/60 focus:bg-bg transition-colors"
          />
          <button
            type="submit"
            disabled={status === 'sending'}
            className="btn-primary w-full justify-center"
          >
            {status === 'sending' ? 'sending…' : 'send magic link'}
          </button>
        </form>

        {status === 'sent' && (
          <div className="text-sm text-green font-mono border border-green/30 bg-green/5 rounded-md p-3">
            {message}
          </div>
        )}
        {status === 'error' && (
          <div className="text-sm text-red font-mono border border-red/30 bg-red/5 rounded-md p-3">
            {message}
          </div>
        )}
      </div>
    </div>
  );
}
